export default "__VITE_ASSET__DIErdRDs__"